import { IconButton } from '@chakra-ui/react'

import { Icon } from '../../components/Icons/Icon'
import { Tooltip } from '../../components/Tooltip/Tooltip'

type TableAutosizeAllButtonProps = {
  onClick: () => void
}

/** Toolbar control that instantly autosizes every visible column. */
export const TableAutosizeAllButton = ({
  onClick,
}: TableAutosizeAllButtonProps) => (
  <Tooltip label="Autosize All Columns" placement="top">
    <IconButton
      variant="controlButton"
      aria-label="Autosize All Columns"
      data-testid="table-autosize-all-columns-button"
      icon={<Icon icon="AutosizeIcon" boxSize="16px" m="-2px" />}
      onClick={onClick}
    />
  </Tooltip>
)
